import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';
import admpNewsSearchData, { AdmpNewsSearchData } from '@/shared/model/smallPayloadModels/admpNewsSearchData';
import DateField from '@/components/_common/date-field/DateField.vue';
import DateUtils from '@/shared/utils/DateUtils';

const logger = new Logger('search-form-admp-news');
const admpNewsModule = namespace('admpNews');
const authModule = namespace('auth');

@Component({
  components: { DateField },
})
export default class SearchFormAdmpNews extends Vue {
  @admpNewsModule.Action('updateAdmpNewsSearchData')
  private actionUpdateAdmpNewsSearchData!: any;
  @admpNewsModule.Getter('isSearchDataEmpty')
  private isSearchDataEmpty!: any;
  @admpNewsModule.Getter('getAdmpNewsSearchData')
  private getAdmpNewsSearchData!: any;

  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserInAzureAdminGroupGetter!: any;
  @authModule.Getter('isUserOnlyGs')
  private isUserOnlyGs!: any;

  @authModule.Getter('zrNummer')
  private zrNummer!: any;
  @authModule.Getter('zrNummerWithRoles')
  private zrNummerWithRoles!: any;
  @authModule.Getter('isDevEnv')
  private isDevEnv!: any;

  created() {
    this.admpNewsSearchData = this.getAdmpNewsSearchData || admpNewsSearchData.defaultData();
  }

  async mounted() {}

  isSearchDataWasCleared = false;
  @Watch('isSearchDataEmpty', { deep: true })
  public async onIsSearchDataEmpty(newVal: boolean, oldVal: boolean) {
    logger.log('isSearchDataEmpty isSearchDataEmpty :>> ', newVal);
    if (newVal == true) {
      this.isSearchDataWasCleared = true; // avoid eternal loop on clearing `admpNewsSearchData` (watcher glitch without this variable)
      this.admpNewsSearchData = admpNewsSearchData.defaultData();
    }
  }

  @Watch('admpNewsSearchData', { deep: true })
  public async onOptionsFilterChanged(newVal: AdmpNewsSearchData, oldVal: AdmpNewsSearchData) {
    // avoid loop when `admpNewsSearchData` was reset
    if (!this.isSearchDataWasCleared) {
      // (GSP-102) Always take into account the `zrNummer` to avoid show all records for `gsUser`
      // const payload = Object.assign({}, this.admpNewsSearchData);
      // payload.isUserInAzureAdminGroup = this.isUserInAzureAdminGroupGetter;
      // payload.zrNummer = this.getZrNummerDependOnRole();
      // payload.favorite = this.admpNewsSearchData.favorite;
      // payload.status = this.admpNewsSearchData.status;
      const payload: AdmpNewsSearchData = {
        ...newVal,
      };
      console.log(
        '-----------action GetAdmpNewsList-----admpNewsSearchData------updateAdmpNewsSearchData--------------------------------------  ===>>>  data ',
        payload,
        '  newVal  ',
        newVal,
        '  this.isUserInAzureAdminGroupGetter   ',
        this.isUserInAzureAdminGroupGetter
      );
      this.actionUpdateAdmpNewsSearchData(payload); // (GSP-075) use `Object.assign` to break reference for `admpNewsSearchData` to get new data from backend on any input clear or multiple select
    }
    this.isSearchDataWasCleared = false;
  }

  getZrNummerDependOnRole() {
    let result = this.isUserOnlyGs ? this.zrNummerWithRoles.zrdocumentZrNummer + '' || '-' : this.zrNummer + '';
    return result;
  }

  statuses = [
    {
      text: this.$i18n.t(`text_all`), //'Alle',
      value: null,
    },
    {
      text: this.$i18n.t(`read_text`), //'Gelesen',
      value: true,
    },
    {
      text: this.$i18n.t(`unread_text`), //'Offen',
      value: false,
    },
  ];

  favoriteValues = [
    {
      text: this.$i18n.t(`text_all`), //'Alle',
      value: null,
    },
    {
      text: this.$i18n.t(`text_yes`), //'Ja',
      value: true,
    },
    {
      text: this.$i18n.t(`text_no`), //'Nein',
      value: false,
    },
  ];

  admpNewsSearchData = admpNewsSearchData.defaultData();

  deltas = [];

  @Watch('$i18n.locale')
  private onLocaleChanged() {
    console.log('locale :>> ', this.$i18n.locale);
    document.title = this.$i18n.tc('news_tab');
    // let backendIndices = this.getZrDocumentsStatuses.map((x: any) => x.index);
    // this.statuses = statusesWithLocale(backendIndices);
    console.log('zrStatusesList :>> ', this.statuses);
  }

  changeDate(value: any) {
    this.admpNewsSearchData.datum = value || undefined; // new Date(value).toJSON();
    // (GSP-102) Always take into account the `zrNummer` to avoid show all records for `gsUser`
    const payload = Object.assign({}, this.admpNewsSearchData);
    this.admpNewsSearchData = Object.assign({}, payload); // workaround (sometimes data change is just ignored by watcher)
  }

  searchStatusInput = '';
  searchSupplierInput = '';

  clearSearchInput() {
    this.searchStatusInput = '';
    this.searchSupplierInput = '';
  }

  get isSearchFormHasData() {
    const searchDataItem = this.admpNewsSearchData;
    return searchDataItem.status !== null || searchDataItem.favorite !== null || !!searchDataItem.datum;
  }
}
